import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function EscalationBanner({ escalations, onView }) {
  if (!Array.isArray(escalations) || escalations.length === 0) {
    return null;
  }

  const latest = escalations[0];
  const count = escalations.length;
  const label = count === 1 ? 'conversation needs help' : 'conversations need help';
  const customerLabel = latest.customer_name || latest.customer_id || 'A customer';

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        padding: '12px 16px',
        marginBottom: '16px',
        border: '1px solid rgba(245, 158, 11, 0.35)',
        borderRadius: '14px',
        background: 'rgba(245, 158, 11, 0.08)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', minWidth: 0 }}>
        <AlertTriangle size={18} style={{ color: '#d97706', flexShrink: 0 }} />
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 600, color: '#7c2d12' }}>
            {count} {label}
          </div>
          <div style={{ color: '#92400e', fontSize: '0.92rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            Latest: {customerLabel}{latest.original_message ? ` - "${latest.original_message}"` : ''}
          </div>
        </div>
      </div>
      <button
        type="button"
        className="btn primary"
        onClick={() => onView?.(latest.customer_id)}
        style={{ flexShrink: 0 }}
      >
        View
      </button>
    </div>
  );
}
